/**
 * Drawer de filtros en tienda (BeRocket).
 */
export function initShopFilters() {
    const open = () => {
        const filters = document.getElementById('shop-filters');
        const overlay = document.querySelector('.shop-archive__overlay');
        const toggle = document.querySelector('.shop-filters-toggle');

        if (!filters) {
            return;
        }

        filters.classList.add('is-open');
        document.body.classList.add('shop-filters-open');
        if (overlay) {
            overlay.hidden = false;
        }
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
        }
    };

    const close = () => {
        const filters = document.getElementById('shop-filters');
        const overlay = document.querySelector('.shop-archive__overlay');
        const toggle = document.querySelector('.shop-filters-toggle');

        filters?.classList.remove('is-open');
        document.body.classList.remove('shop-filters-open');
        if (overlay) {
            overlay.hidden = true;
        }
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
        }
    };

    document.addEventListener('click', (event) => {
        if (event.target.closest('.shop-filters-toggle')) {
            const filters = document.getElementById('shop-filters');
            if (filters?.classList.contains('is-open')) {
                close();
            } else {
                open();
            }
            return;
        }

        if (event.target.closest('.shop-filters-close') || event.target.closest('.shop-archive__overlay')) {
            close();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            close();
        }
    });
}
